export default {
      id: "life-insurance-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#life-insurance",
      toString: function () {
        return this.url;
      }
    }